import { useState, useEffect } from 'react';

const THEME_KEY = 'bardplay-reading-theme';

const useTheme = () => {
  const getInitialTheme = () => {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
    // Fall back to system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)')?.matches) {
      return 'dark';
    }
    return 'light';
  };

  const [theme, setTheme] = useState(() => {
    try {
      return getInitialTheme();
    } catch {
      return 'light';
    }
  });

  // Listen for system preference changes (only if user hasn't manually set a preference)
  useEffect(() => {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored) return; // User has a manual preference, don't override

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setTheme(e?.matches ? 'dark' : 'light');
    };

    mediaQuery?.addEventListener('change', handleChange);
    return () => mediaQuery?.removeEventListener('change', handleChange);
  }, []);

  const toggleTheme = () => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(THEME_KEY, next);
      } catch {}
      return next;
    });
  };

  const isDark = theme === 'dark';

  return { theme, isDark, toggleTheme };
};

export default useTheme;
